<script>
import { GlTabs, GlTab } from '@gitlab/ui';
import { AGENTS_PLATFORM_INDEX_ROUTE } from 'ee/ai/duo_agents_platform/router/constants';
import NoCreditsBanner from '../../../components/common/no_credits_banner.vue';
import AgentFlowHeader from './agent_flow_header.vue';
import AgentFlowInfo from './agent_flow_info.vue';
import AgentActivityLogs from './agent_activity_logs.vue';

export default {
  name: 'AgentFlowDetails',
  components: {
    AgentFlowHeader,
    AgentFlowInfo,
    AgentActivityLogs,
    NoCreditsBanner,
    GlTabs,
    GlTab,
  },
  inject: {
    isSidePanelView: { default: false },
    creditsAvailable: { default: true },
  },
  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    status: {
      required: true,
      type: String,
    },
    humanStatus: {
      required: true,
      type: String,
    },
    agentFlowDefinition: {
      required: true,
      type: String,
    },
    duoMessages: {
      type: Array,
      required: true,
    },
    executorUrl: {
      type: String,
      required: false,
      default: '',
    },
    createdAt: {
      type: String,
      required: true,
    },
    updatedAt: {
      type: String,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    workflowId: {
      type: String,
      required: true,
    },
    canUpdateWorkflow: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['cancel-session'],
  AGENTS_PLATFORM_INDEX_ROUTE,
};
</script>
<template>
  <div>
    <agent-flow-header
      v-if="!isSidePanelView"
      :is-loading="isLoading"
      :agent-flow-definition="agentFlowDefinition"
    />
    <no-credits-banner v-if="!creditsAvailable" />
    <div class="gl-flex" :class="{ 'gl-mt-6': !isSidePanelView }">
      <gl-tabs class="gl-w-full" content-class="gl-py-0">
        <gl-tab :title="s__('DuoAgentPlatform|Activity')">
          <agent-activity-logs
            class="gl-overflow-auto"
            :created-at="createdAt"
            :duo-messages="duoMessages"
            :is-loading="isLoading"
            :status="status"
            :updated-at="updatedAt"
            :user-id="userId"
          />
        </gl-tab>
        <gl-tab :title="s__('DuoAgentPlatform|Details')">
          <agent-flow-info
            class="gl-mt-3"
            :is-loading="isLoading"
            :status="status"
            :human-status="humanStatus"
            :agent-flow-definition="agentFlowDefinition"
            :created-at="createdAt"
            :project="project"
            :updated-at="updatedAt"
            :executor-url="executorUrl"
            :workflow-id="workflowId"
            :user-id="userId"
            :can-update-workflow="canUpdateWorkflow"
            @cancel-session="$emit('cancel-session')"
          />
        </gl-tab>
      </gl-tabs>
    </div>
  </div>
</template>
